import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import API, { methods } from '../canvas-api';
import { handleGenericError } from '../common';
import { actions } from '../../reducers/printers/printers';
import { sanitizePrinterData } from './common';

export default function* updatePrinterStyles(action) {
  try {
    const { printerId, styleId, styles } = action.payload;

    const response = yield call(API, {
      method: methods.POST,
      path: `printers/${printerId}/styles/${styleId}`,
      body: styles,
    });
    if (response === null) return;

    const sanitizedPrinter = sanitizePrinterData(response.printer);
    yield put(actions.updateStyleProfileSuccess(sanitizedPrinter));
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
